import { Tooltip } from 'devextreme-react';
import './RenderModeForm.scss';
import { view, new as newI, edit_icon } from '../../../images/icons'; // Importamos el SVG como URL
import { formatMessage } from 'devextreme/localization';

export const RenderModeForm = ({ mode, contentClass = '', showText = true }: { mode: 'new' | 'update' | 'view' | 'loading'; contentClass?: string; showText?: boolean }) => {
  let text;
  let icon;

  switch (mode) {
    case 'new':
      text = formatMessage('modeNewItem');
      icon = <img src={newI} alt="View Icon" className="customicon" />;
      break;
    case 'update':
      text = formatMessage('modeUpdateItem');
      icon = <img src={edit_icon} alt="View Icon" className="customicon" />;
      break;
    case 'view':
      text = formatMessage('modeViewItem');
      icon = <img src={view} alt="View Icon" className="customicon" />;
      break;
    case 'loading':
      text = formatMessage('modeLoading');
      icon = <i className="dx-icon dx-icon-loading customicon"></i>;
      break;
    default:
      text = formatMessage('modeUndefined');
      icon = null;
      break;
  }

  return (
    <div className={`status status-contact color-${mode} ${contentClass}`}>
      <Tooltip target={'#message'} showEvent="mouseenter" hideEvent="mouseleave" hideOnOutsideClick={false}>
        <div>
          {formatMessage('modeActual')} - {text}
        </div>
      </Tooltip>
      <span id="message" className='inline-content'>
        {icon}
      </span>
    </div>
  );
};
